import axios from "axios";
const URL = process.env.REACT_APP_API_URL;

interface IFilledFields {
  name: string;
  value: number;
  shortName: string;
}

export interface IPopularItem {
  id: string;
  filledFields: IFilledFields[];
  profile: {
    id: string;
    profileType: string;
    name: string;
    imageUrl: string;
    iconUrl: string;
    calculationFields: [
      {
        name: string;
        shortName: string;
        defautValue: any;
      }
    ];
  };
}

interface IResponse {
  items: IPopularItem[];
}

export const fetchPopularService = () => {
  return axios.get<IResponse>(`${URL}/popular-profile/`);
};

export const fetchPopularByIdService = (popularId) => {
  return axios.get(`${URL}/popular-profile/${popularId}`);
};
